import { render, staticRenderFns } from "./zifuchuan.vue?vue&type=template&id=8ba15422"
import script from "./zifuchuan.vue?vue&type=script&lang=ts"
export * from "./zifuchuan.vue?vue&type=script&lang=ts"
import style0 from "./zifuchuan.vue?vue&type=style&index=0&id=8ba15422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports